import { render, staticRenderFns } from "./docdownload.vue?vue&type=template&id=3780338c&scoped=true&"
import script from "./docdownload.vue?vue&type=script&lang=js&"
export * from "./docdownload.vue?vue&type=script&lang=js&"
import style0 from "./docdownload.vue?vue&type=style&index=0&id=3780338c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3780338c",
  null
  
)

export default component.exports